function initScrollGradient() {
    const LIGHT_BG = `rgb(${CONFIG.gradientLight.join(',')})`;
    const DARK_BG = `rgb(${CONFIG.gradientDark.join(',')})`;
    const navEl = document.querySelector('nav');
    // Inyectar la transición CSS en el body si no existe
    // (también se puede poner en base.css, pero así es auto-contenido)
    document.body.style.transition = 'background-color 1s ease';
    function getCurrentSectionColor() {
        const vh = window.innerHeight;
        const refY = vh * 0.5; // centro del viewport
        let best = null;
        let bestDist = Infinity;
        CONFIG.gradientSections.forEach(({ id, light })=>{
            const el = document.getElementById(id);
            if (!el || el.style.display === 'none') return;
            const rect = el.getBoundingClientRect();
            // Si el punto de referencia está dentro de esta sección → ganadora directa
            if (refY >= rect.top && refY <= rect.bottom) {
                best = {
                    light
                };
                bestDist = -1; // señal de coincidencia exacta
                return;
            }
            // Si ya tenemos coincidencia exacta, no sobreescribir
            if (bestDist === -1) return;
            // Si no, guardar la más cercana al centro del viewport
            const center = (rect.top + rect.bottom) / 2;
            const dist = Math.abs(center - refY);
            if (dist < bestDist) {
                bestDist = dist;
                best = {
                    light
                };
            }
        });
        return best;
    }
    function applyColors() {
        const sec = getCurrentSectionColor();
        if (!sec) return;
        const isLight = sec.light;
        document.body.style.backgroundColor = isLight ? LIGHT_BG : DARK_BG;
        if (navEl) {
            // El nav también transiciona suavemente (ya tiene transition en layout.css)
            navEl.style.background = isLight ? 'rgba(250, 247, 242, 0.97)' : 'rgba(44, 36, 25, 0.97)';
            const linkColor = isLight ? 'var(--brown)' : 'var(--gold-light)';
            navEl.querySelectorAll('a').forEach((a)=>a.style.color = linkColor);
        }
    }
    /** Parallax suave en elementos con data-parallax="speed" */ function applyParallax() {
        document.querySelectorAll('[data-parallax]').forEach((el)=>{
            const speed = parseFloat(el.dataset.parallax) || 0.3;
            const rect = el.getBoundingClientRect();
            const center = rect.top + rect.height / 2 - window.innerHeight / 2;
            el.style.transform = `translateY(${center * speed}px)`;
        });
    }
    let rafScheduled = false;
    function scheduleUpdate() {
        if (!rafScheduled) {
            rafScheduled = true;
            requestAnimationFrame(()=>{
                applyColors();
                applyParallax();
                rafScheduled = false;
            });
        }
    }
    window.addEventListener('scroll', scheduleUpdate, {
        passive: true
    });
    window.addEventListener('resize', scheduleUpdate);
    // Actualizar también durante scroll suave al hacer click en nav
    document.querySelectorAll('nav a').forEach((link)=>{
        link.addEventListener('click', ()=>{
            let ticks = 0;
            const iv = setInterval(()=>{
                applyColors();
                applyParallax();
                if (++ticks >= 60) clearInterval(iv);
            }, 16);
        });
    });
    applyColors();
    applyParallax();
}

//# sourceMappingURL=public.77d84f98.js.map
